/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Sanction_IssuedInputs */



/**
* | output |
* | --- |
* | "Issued: {date}" |
*
* @param {Sanction_IssuedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_issued = /** @type {((inputs: Sanction_IssuedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_IssuedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Émise le : ${i?.date}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Emitida: ${i?.date}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Emitida: ${i?.date}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Emessa: ${i?.date}`)
	return /** @type {LocalizedString} */ (`Issued: ${i?.date}`)
});